import * as React from 'react';
import Radio from 'src/components/FormElements/Radio';
import { CourseType } from '../types';

type CourseTypeItem = {
  type: CourseType;
  label: string;
};

type TypeSelectProps = {
  value: CourseType;
  onChange: (value: CourseType) => void;
};

const statuses: CourseTypeItem[] = [
  { type: 'default', label: 'Almindelig kursus' },
  { type: 'advertisement', label: 'Kursus på vej' },
];

const TypeSelect = ({ value, onChange }: TypeSelectProps) => (
  <div className="flex flex-column">
    {statuses.map((item) => (
      <Radio
        key={item.type}
        className="mt1"
        checked={value === item.type}
        onChange={() => onChange(item.type)}
      >
        {item.label}
      </Radio>
    ))}
  </div>
);

export default TypeSelect;



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/Reports/components/TypeSelect.tsx